import commonUtils from "../../utils/common.utils";

export default class OrderDelivering {
    constructor(data) {
        this.mode = data.consumptionPattern;
        this.orderSource = data.orderSource;
        this.customerAdultCount = data.customerAdultCount;
        this.customerChildrenCount = data.customerChildrenCount || null;

        if (this.mode === 0 && data.serverAreaData.dineInTable) {
            // 內用且有桌號
            this.orderServeArea = new orderServeArea(data.serverAreaData)
        } else if (this.mode === 1 && data.serverAreaData.userTableData.areaId) {
            // 現場外帶選擇桌號為 optional
            this.orderServeArea = new orderServeArea(data.serverAreaData)
        } else {
            this.orderServeArea = null
        }

        if (this.mode === 1 && data.serverAreaTakeoutData?.dineInTable && data.serverAreaTakeoutData?.userTableData?.areaId) {
            // 內用外帶專用桌號
            this.orderServeAreaTakeout = new orderServeArea(data.serverAreaTakeoutData)
        } else {
            this.orderServeAreaTakeout = null;
        }

        // 配送資訊（外送/自取時使用）
        this.cityID = null;  // 目前暫不使用
        this.cityAreaID = null;  // 目前暫不使用
        this.address = data.address || null;
        this.recipient = data.recipient || null;
        this.contactPhone = data.contactPhone || null;  // 聯絡電話

        this.deliverTime = data.deliverTime || null;
        this.deliveryPeriod = data.deliveryPeriod || null;
    }
}

class orderServeArea {
    constructor(data) {
        this.id = commonUtils.generateId();
        this.serveArea = new ServeArea(data.dineInTable);
        this.useTableIndex = this.getUseTableIndex(data.userTableData)
    }

    getUseTableIndex(userTableData) {
        if (userTableData.tableIndex == -1 || userTableData.tableIndex == '-1' || userTableData.tableIndex === null || userTableData.tableIndex === undefined) {
            return null
        } else {
            return Number(userTableData.tableIndex)
        }
    }
}

class ServeArea {
    constructor(data) {
        this.id = data.areaId;
        this.enable = data.enable;
        this.name = data.name;
        this.tables = data.tables;
        this.sortingOrder = 0
    }
}
